import React, { Component } from 'react';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { get } from 'lodash';
import styled from 'styled-components';
import NavigationCard from 'components/organisms/home/NavigationCard';
import G90Header from 'components/molecules/home/G90Header';
import AdBlockModal from 'components/molecules/modal/AdBlockerModal';

import { PRODUCT_MANAGER_ADMIN, DASHBOARD_ACCESS, ADMINAREA_ACCESS, CAMPAIGN_ENGINE_ACCESS, PIXEL_QA_ACCESS } from 'constants/capabilities';

const HomeWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const CardWrapper = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
`;

class G90HomeContentContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAdBlockMessage: false,
            cardLinks: [
                {
                    title: 'Campaign Engine',
                    description: 'Campaign Setup, QA and Invoicing',
                    iconName: 'icon-cog',
                    iconColor: 'positive',
                    linkURL: get(this.props.env, 'REACT_APP_G90_HOME_LINK_UNICORN', '/unicorn/'),
                    isAuthed: this.props.capabilities.includes(CAMPAIGN_ENGINE_ACCESS)
                },
                {
                    title: 'Reporting Dashboards',
                    description: 'View Your Dashboards',
                    iconName: 'icon-summary',
                    iconColor: 'tangerine',
                    linkURL: '/dashboard',
                    isAuthed: this.props.capabilities.includes(DASHBOARD_ACCESS)
                },
                {
                    title: 'Insights',
                    description: 'Redash SQL Interface',
                    iconName: 'icon-info',
                    iconColor: 'lochmara',
                    linkURL: get(this.props.env, 'REACT_APP_G90_HOME_LINK_REDASH', 'https://gw-data.goodwaygroup.com/'),
                    isAuthed: true
                },
                {
                    title: 'Admin',
                    description: 'Brand, User, and Dashboard Setup',
                    iconName: 'icon-user',
                    iconColor: 'black',
                    linkURL: get(this.props.env, 'REACT_APP_G90_HOME_LINK_ADMIN', '/admin'),
                    isAuthed: this.props.capabilities.includes(ADMINAREA_ACCESS)
                },
                {
                    title: 'Retail Media',
                    description: 'Manage Retail Media Networks',
                    iconName: 'icon-store',
                    iconColor: 'sand',
                    linkURL: '/rmn-portal/',
                    isAuthed: this.props.capabilities.includes(PRODUCT_MANAGER_ADMIN)
                },
                {
                    title: 'Pixel QA',
                    description: 'Monitor pixel activity over the last 30 days',
                    iconName: 'icon-search',
                    iconColor: 'shakespeare',
                    linkURL: '/pixel-qa',
                    isAuthed: this.props.capabilities.includes(PIXEL_QA_ACCESS)
                }
            ]
        };
        this.handleAcceptClick = this.handleAcceptClick.bind(this);
    }

    clickAction(clickPath) {
        if (this.props.push) {
            this.props.push(clickPath);
        }
    }

    handleAcceptClick() {
        this.setState({
            showAdBlockMessage: false
        });
    }


    async checkAdBlocker() {
        let isBlocked;
        async function fetchGoogleAds() {
            try {
                return fetch(
                    new Request('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', {
                        method: 'HEAD',
                        mode: 'no-cors'
                    }))
                    .then(() => {
                        isBlocked = false;
                        return isBlocked;
                    }).catch(() => {
                        isBlocked = true;
                        return isBlocked;
                    });
            } catch (error) {
                isBlocked = true;
                return isBlocked;
            }
        }

        return isBlocked !== undefined ? isBlocked : await fetchGoogleAds();
    }

    async componentDidMount() {
        const isBlocked = await this.checkAdBlocker();
        this.setState({ showAdBlockMessage: isBlocked });
    }

    render() {
        const { cardLinks } = this.state;
        const authedCards = cardLinks.filter(card => card.isAuthed);
        const cardCount = authedCards.length;

        return (
            <HomeWrapper>
                <G90Header />

                <CardWrapper>
                    {authedCards.map((card) => {
                        const { title, description, iconName, iconColor, linkURL } = card;

                        return <NavigationCard
                            key={title}
                            cardCount={cardCount}
                            title={title}
                            description={description}
                            iconName={iconName}
                            iconColor={iconColor}
                            linkURL={linkURL}
                        />;
                    })}
                </CardWrapper>

                {this.state.showAdBlockMessage &&
                    <AdBlockModal handleClick={this.handleAcceptClick} />
                }
            </HomeWrapper>
        );
    }
}

const mapStateToProps = state => ({
    landingPage: get(state, 'users.currentUser.landingPage', '/'),
    userFirstName: get(state, 'users.currentUser.firstName', ''),
    capabilities: get(state, 'users.currentUser.scope', []),
    env: get(state, 'config.env', {})
});

export default connect(mapStateToProps, { push })(G90HomeContentContainer);



// WEBPACK FOOTER //
// ./src/containers/home/G90HomeContentContainer.js